export default __webpack_public_path__ + "static/media/project-wizard-dashboards_dark.f0109ee3.png";